// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';
import { JsonValueSchema } from '../inputTypeSchemas/JsonValueSchema'
import { AiApplicationKindSchema } from '../inputTypeSchemas/AiApplicationKindSchema'
import { AiApplicationDiscoveryStatusSchema } from '../inputTypeSchemas/AiApplicationDiscoveryStatusSchema'
import { AiApplicationDiscoveryModeSchema } from '../inputTypeSchemas/AiApplicationDiscoveryModeSchema'
import { AiApplicationInterfaceTypeSchema } from '../inputTypeSchemas/AiApplicationInterfaceTypeSchema'
import { AiApplicationMcpTransportSchema } from '../inputTypeSchemas/AiApplicationMcpTransportSchema'

/////////////////////////////////////////
// AI APPLICATION CONFIG SCHEMA
/////////////////////////////////////////

export const AiApplicationConfigSchema = z.object({
  aiKind: AiApplicationKindSchema,
  discoveryStatus: AiApplicationDiscoveryStatusSchema,
  discoveryMode: AiApplicationDiscoveryModeSchema,
  discoveryRunMode: AiApplicationDiscoveryModeSchema.nullable(),
  interfaceTypes: AiApplicationInterfaceTypeSchema.array(),
  mcpTransport: AiApplicationMcpTransportSchema.nullable(),
  discoveryStartedAt: z.coerce.date().nullable(),
  discoveryRunId: z.string().nullable(),
  discoveryRunHistory: JsonValueSchema.nullable(),
  description: z.string().nullable(),
  agentPurpose: z.string().nullable(),
  technicalContext: z.string().nullable(),
  codeDiscoveryHints: z.string().nullable(),
  credentialSummary: z.string().nullable(),
  businessContext: z.string().nullable(),
  testingInstructions: z.string().nullable(),
  mcpEnv: JsonValueSchema.nullable(),
  mcpServerId: z.string().nullable(),
})

export type AiApplicationConfig = z.infer<typeof AiApplicationConfigSchema>

export default AiApplicationConfigSchema;
